/* eslint-disable @typescript-eslint/no-unused-expressions, @typescript-eslint/strict-boolean-expressions */

import { useRecoilState } from 'recoil';
import { SxProps } from '@mui/material';
import FullscreenExitSharpIcon from '@mui/icons-material/FullscreenExitSharp';
import FullscreenSharpIcon from '@mui/icons-material/FullscreenSharp';
import useIsMobile from 'hooks/useIsMobile';
import { chartExpandedState } from '../../states';
import { ChartSizingButton } from './ChartSizingButton';

interface FullScreenButtonProps {
  setOpenSettings?: React.Dispatch<React.SetStateAction<boolean>>;
  sx?: SxProps;
  withText?: boolean;
  onClick?: () => void;
}

export const FullScreenButton = ({
  setOpenSettings,
  sx,
  withText,
  onClick,
}: FullScreenButtonProps) => {
  const [chartExpanded, setChartExpanded] = useRecoilState(chartExpandedState);
  const isMobile = useIsMobile();
  if (isMobile) {
    return null;
  }

  return (
    <ChartSizingButton
      onClick={() => {
        if (setOpenSettings) {
          setOpenSettings(!chartExpanded);
        }
        setChartExpanded(!chartExpanded);
        onClick != null && onClick();
      }}
      icon={
        chartExpanded ? <FullscreenExitSharpIcon /> : <FullscreenSharpIcon />
      }
      title={chartExpanded ? 'Close Full Screen' : 'Open Full Screen'}
      withText={withText}
      buttonSx={sx}
    />
  );
};
